import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from './AppSidebar';
import { AppHeader } from './AppHeader';
import { RouteSync } from './RouteSync';
import { AppProvider } from '@/contexts/AppContext';
import { BrandProvider } from '@/contexts/BrandContext';

export function AppLayout() {
  return (
    <AppProvider>
      <BrandProvider>
        <SidebarProvider>
          <RouteSync />
          <div className="flex min-h-screen w-full bg-wt-bg-primary text-foreground">
            <AppSidebar />
            <SidebarInset>
              <AppHeader />
              <main className="flex-1 p-4 md:p-6">
                <Outlet />
              </main>
            </SidebarInset>
          </div>
        </SidebarProvider>
      </BrandProvider>
    </AppProvider>
  );
}
